// src/components/landing/ReframeFlow.tsx
//
// Section 3 flow — rebuilt on the shadcn Item primitive (ItemGroup /
// Item / ItemMedia / ItemContent), matching the pattern this component
// was actually designed for (a connected sequence of labeled, iconed
// rows) rather than hand-rolled divs.

import * as React from 'react';
import {
  ItemGroup,
  Item,
  ItemMedia,
  ItemContent,
  ItemTitle,
  ItemDescription,
  ItemSeparator,
} from '../ui/item';
import { FileText, ScanSearch, Check, AlertTriangle } from 'lucide-react';

export const ReframeFlow: React.FC = () => {
  return (
    <ItemGroup className="max-w-md mx-auto">
      <Item variant="outline">
        <ItemMedia variant="icon">
          <FileText />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>Transaction</ItemTitle>
          <ItemDescription>Comes in — from Xero, Marqeta, wherever it happened.</ItemDescription>
        </ItemContent>
      </Item>

      <ItemSeparator />

      <Item variant="outline">
        <ItemMedia variant="icon">
          <ScanSearch />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>Checked against your rules</ItemTitle>
          <ItemDescription>The rules you set once, applied every time.</ItemDescription>
        </ItemContent>
      </Item>

      <ItemSeparator />

      <Item variant="outline">
        <ItemMedia variant="icon">
          <Check />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>Matches — closes</ItemTitle>
          <ItemDescription>No further action needed.</ItemDescription>
        </ItemContent>
      </Item>

      <Item variant="muted" className="border-brand-accent/30">
        <ItemMedia variant="icon" className="text-brand-accent">
          <AlertTriangle />
        </ItemMedia>
        <ItemContent>
          <ItemTitle>Doesn't — flagged</ItemTitle>
          <ItemDescription>With the reason attached, ready for a decision.</ItemDescription>
        </ItemContent>
      </Item>
    </ItemGroup>
  );
};